import { render, staticRenderFns } from "./userInfoModal.vue?vue&type=template&id=3976337a&scoped=true"
import script from "./userInfoModal.vue?vue&type=script&lang=js"
export * from "./userInfoModal.vue?vue&type=script&lang=js"
import style0 from "./userInfoModal.vue?vue&type=style&index=0&id=3976337a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3976337a",
  null
  
)

export default component.exports